import React from 'react';
import {LinkPiles} from '../components/common/linkpiles/LinkPiles';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import SeoLinkpile from '../components/common/seo-linkpile/SeoLinkpile';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import {TESTS} from '../../shared/utils/abacus';

export const Template = () => (
    <React.Fragment>
        <main className="app-main">
            <LinkPiles />
        </main>
        <MvtTest test={TESTS.SEO_LINKPILE} report reportOnMount>
            <MmgLinks />
            {withErrorBoundary(<SeoLinkpile />)}
        </MvtTest>
    </React.Fragment>
);
